/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Subscribed_Card_Membership_End_Date_CnaInputs */

const en_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const ar_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const de_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const es_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const fr_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const it_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const ja_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const ko_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const pt_br_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const ru_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const th_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const tr_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Expires on ${i?.date}
No auto-renewal after expiration`)
};

const zh_cn_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将于 ${i?.date} 到期
到期后不会自动续费`)
};

const zh_tw_subscribed_card_membership_end_date_cna = /** @type {(inputs: Subscribed_Card_Membership_End_Date_CnaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将于 ${i?.date} 到期
到期后不会自动续费`)
};

/**
* | output |
* | --- |
* | "Expires on {date} No auto-renewal after expiration" |
*
* @param {Subscribed_Card_Membership_End_Date_CnaInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_membership_end_date_cna = /** @type {((inputs: Subscribed_Card_Membership_End_Date_CnaInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_Membership_End_Date_CnaInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "ar") return ar_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "de") return de_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "es") return es_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "fr") return fr_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "it") return it_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "ja") return ja_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "ko") return ko_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "ru") return ru_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "th") return th_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "tr") return tr_subscribed_card_membership_end_date_cna(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_membership_end_date_cna(inputs)
	return zh_tw_subscribed_card_membership_end_date_cna(inputs)
});